import logo from './images/logo.png';
import './App.css';
import React, { useEffect, useState } from "react";
import MainPage from './MainPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { geoPages } from './geoData';


const FadeIn = ({children}) => <div className='fade-in'>
  {children}
</div>


const FadeOut = ({children}) => <div className='fade-out'>
  {children}
</div>


function App() {

  const [loaded, setLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // const isMobileFormat = ((window.innerWidth > window.innerHeight ? window.innerHeight : window.innerWidth) <= 500)
    const isMobileFormat = Math.min(window.innerWidth, window.innerHeight) < 768;
    
    setIsMobile(isMobileFormat);
    setTimeout(() => {
      setLoaded(true)
    }, 3000)
  }, [])

  return (
    <div className="App">
      <header className="App-header">
        <title>Darduin Carrelage</title>
        {
          loaded 
          ? <FadeIn>
            {/* <MainPage isMobile={isMobile} /> */}
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<MainPage isMobile={isMobile} />} />
                {geoPages.map(page => (
                  <Route
                    key={page.slug}
                    path={`/:slug`}
                    element={<MainPage isMobile={isMobile} />}
                  />
                ))}
              </Routes>
            </BrowserRouter>
          </FadeIn>
          : <FadeOut><img src={logo} alt="logo" className="App-logo heartbeat img-shadow" /></FadeOut>
        }
        
        
      </header>
    </div>
  );
}

export default App;
